import { apiClient, getAuthToken } from './client';

export type TagColor =
  | 'neutral'
  | 'green'
  | 'orange'
  | 'red'
  | 'blue'
  | 'purple'
  | 'teal'
  | 'brown';

export type TagOption = { value: string; label: string; color: TagColor };
export type WorkspaceTag = { id: string; name: string; color: TagColor };

export const queryTagOptions = async (
  input: { projectId?: string | null },
  orgId?: string | null,
): Promise<TagOption[]> => {
  const params = new URLSearchParams();
  if (input.projectId) {
    params.set('projectId', input.projectId);
  }
  const query = params.toString();
  const path = query.length > 0 ? `/tags?${query}` : '/tags';
  return await apiClient.get<TagOption[]>(path, {
    token: getAuthToken(),
    orgId,
  });
};

export const updateTagColor = async (
  input: { name: string; color: TagColor },
  orgId?: string | null,
): Promise<void> => {
  await apiClient.patch<{ status: 'updated' }>(
    '/tags/color',
    { name: input.name, color: input.color },
    {
      token: getAuthToken(),
      orgId,
      retries: 1,
    },
  );
};

export const queryWorkspaceTags = async (orgId?: string | null): Promise<WorkspaceTag[]> => {
  return await apiClient.get<WorkspaceTag[]>('/tags/manage', {
    token: getAuthToken(),
    orgId,
    retries: 1,
  });
};

export const updateWorkspaceTag = async (
  input: { id: string; name: string; color: TagColor },
  orgId?: string | null,
): Promise<WorkspaceTag> => {
  return await apiClient.patch<WorkspaceTag>(
    `/tags/${input.id}`,
    { name: input.name, color: input.color },
    {
      token: getAuthToken(),
      orgId,
      retries: 1,
    },
  );
};

export const createWorkspaceTag = async (
  input: { name: string; color: TagColor },
  orgId?: string | null,
): Promise<WorkspaceTag> => {
  return await apiClient.post<WorkspaceTag>(
    '/tags/manage',
    { name: input.name, color: input.color },
    {
      token: getAuthToken(),
      orgId,
      retries: 1,
    },
  );
};

export const deleteWorkspaceTag = async (
  input: { id: string },
  orgId?: string | null,
): Promise<{ status: 'deleted' }> => {
  return await apiClient.post<{ status: 'deleted' }>(`/tags/${input.id}/delete`, undefined, {
    token: getAuthToken(),
    orgId,
    retries: 1,
  });
};
